export const pattern5Data = [
  {
    id: 1,
    koreanChunks: ["그 회사는", "임명했다", "그를", "새로운 매니저로"],
    englishChunks: ["The company", "appointed", "him", "the new manager"],
    fullEnglish: "The company appointed him the new manager.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 2,
    koreanChunks: [
      "그들은",
      "명명했다",
      "그 프로젝트를",
      "'그린 퓨처 이니셔티브'라고",
    ],
    englishChunks: ["They", "named", "the project", "Green Future Initiative"],
    fullEnglish: "They named the project Green Future Initiative.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 3,
    koreanChunks: ["이사회는", "선출했다", "그녀를", "CEO로"],
    englishChunks: ["The board of directors", "elected", "her", "the CEO"],
    fullEnglish: "The board of directors elected her the CEO.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 4,
    koreanChunks: [
      "그 캠페인의 성공은",
      "만들었다",
      "그 브랜드를",
      "잘 알려진 이름으로",
    ],
    englishChunks: [
      "The success of the campaign",
      "made",
      "the brand",
      "a household name",
    ],
    fullEnglish: "The success of the campaign made the brand a household name.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 5,
    koreanChunks: [
      "트레이너는",
      "간주한다",
      "이 운동을",
      "필수적인 부분 프로그램",
    ],
    englishChunks: [
      "The trainer",
      "considers",
      "this exercise",
      "an essential part of the program",
    ],
    fullEnglish:
      "The trainer considers this exercise an essential part of the program.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 6,
    koreanChunks: ["새로운 규정은", "만들었다", "그 과정을", "더욱 복잡하게"],
    englishChunks: [
      "The new regulations",
      "made",
      "the process",
      "more complicated",
    ],
    fullEnglish: "The new regulations made the process more complicated.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 7,
    koreanChunks: [
      "고객들의 피드백은",
      "도움이 되었다",
      "회사가",
      "경쟁력을 유지하는 데",
    ],
    englishChunks: [
      "The feedback from customers",
      "helped",
      "the company",
      "stay competitive",
    ],
    fullEnglish:
      "The feedback from customers helped the company stay competitive.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 8,
    koreanChunks: ["그들은", "생각했다", "그 제안이", "매우 흥미롭다고"],
    englishChunks: ["They", "found", "the proposal", "very interesting"],
    fullEnglish: "They found the proposal very interesting.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 9,
    koreanChunks: [
      "공사 지연은",
      "두었다",
      "회사를",
      "재정적으로 불안정한 상태로",
    ],
    englishChunks: [
      "The construction delay",
      "left",
      "the company",
      "financially unstable",
    ],
    fullEnglish:
      "The construction delay left the company financially unstable.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 10,
    koreanChunks: [
      "보안 조치는",
      "유지한다",
      "시스템을",
      "안전하게 사이버 공격으로부터 ",
    ],
    englishChunks: [
      "The security measures",
      "keep",
      "the system",
      "safe from cyberattacks",
    ],
    fullEnglish:
      "The security measures keep the system safe from cyberattacks.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 11,
    koreanChunks: [
      "매니저는",
      "요청했다",
      "직원들에게",
      "제출하도록 보고서를 ",
      "금요일까지",
    ],
    englishChunks: [
      "The manager",
      "asked",
      "the employees",
      "to submit their reports",
      "by Friday",
    ],
    fullEnglish:
      "The manager asked the employees to submit their reports by Friday.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 12,
    koreanChunks: [
      "강사는",
      "말했다",
      "학생들에게",
      "복습하라고 자료를",
      "시험 전에 ",
    ],
    englishChunks: [
      "The instructor",
      "told",
      "the students",
      "to review the materials",
      "before the test",
    ],
    fullEnglish:
      "The instructor told the students to review the materials before the test.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 13,
    koreanChunks: [
      "CEO는",
      "기대한다",
      "팀이",
      "완료할 것으로 프로젝트를",
      "일정보다 앞서 ",
    ],
    englishChunks: [
      "The CEO",
      "expects",
      "the team",
      "to complete the project ",
      "ahead of schedule",
    ],
    fullEnglish:
      "The CEO expects the team to complete the project ahead of schedule.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 14,
    koreanChunks: [
      "그 시스템은",
      "허용한다",
      "사용자들이",
      " 맞춤화할 수 있도록 자신의 설정을",
    ],
    englishChunks: [
      "The system",
      "allows",
      "users",
      "to customize their settings",
    ],
    fullEnglish: "The system allows users to customize their settings.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 15,
    koreanChunks: [
      "인사부는",
      "조언했다",
      "직원들에게",
      "업데이트하라고 연락처 정보를 ",
    ],
    englishChunks: [
      "The HR department",
      "advised",
      "the employees",
      "to update their contact information",
    ],
    fullEnglish:
      "The HR department advised the employees to update their contact information.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 16,
    koreanChunks: ["매니저는", "시켰다", "인턴들이", "준비하도록 발표를"],
    englishChunks: [
      "The manager",
      "made",
      "the interns",
      "prepare a presentation",
    ],
    fullEnglish: "The manager made the interns prepare a presentation.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 17,
    koreanChunks: [
      "감독관은",
      "허락했다",
      "직원들이",
      "일찍 퇴근하도록",
      "금요일에 ",
    ],
    englishChunks: [
      "The supervisor",
      "let",
      "the staff",
      "leave early ",
      "on Friday",
    ],
    fullEnglish: "The supervisor let the staff leave early on Friday.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 18,
    koreanChunks: [
      "나는",
      "들었다",
      "그가",
      "훌륭한 연설을 하는 것을",
      "세미나에서 ",
    ],
    englishChunks: [
      "I",
      "heard",
      "him",
      "give an excellent speech",
      "at the seminar",
    ],
    fullEnglish: "I heard him give an excellent speech at the seminar.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 19,
    koreanChunks: [
      "그녀는",
      "보았다",
      "기술자가",
      "해결하는 것을 문제를",
      "실시간으로",
    ],
    englishChunks: [
      "She",
      "saw",
      "the technician",
      "fix the issue",
      " in real time",
    ],
    fullEnglish: "She saw the technician fix the issue in real time.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
  {
    id: 20,
    koreanChunks: [
      "그 회사는",
      "시켰다",
      "IT 팀이",
      "설치하게 새로운 보안 소프트웨어를 ",
    ],
    englishChunks: [
      "The company",
      "had",
      "the IT team",
      "install new security software",
    ],
    fullEnglish: "The company had the IT team install new security software.",
    explanation:
      "주어(S) + 동사(V) + 목적어(O) + 목적격보어(OC) 구조의 5형식 문장입니다.",
  },
];
